import { pageShowListener } from '@utils/index';
import { isMobileSafari } from '@services/browser-detection-service';
import { PolicyType, isSubscriptionPopupVisibile, subscriptionCookieInfo, canShowSubscriptionPopupInJPP } from '@services/subscription-popup-service';
import { createCookie, readCookie } from '@utils/cookie';
import { JtagService } from '@services/jtag-service';
import ProposalModal from './doubleOptIn';
import SingleConfirmationProposalModal from './singleOptIn';

const initModal = (jrConfigGlobal: Readonly<JrConfigGlobal>, source = 'auto') => {

  const {
    feature: {
      confirmationSingleClickEnabled
    }
  } = jrConfigGlobal;

  if (confirmationSingleClickEnabled) {
    new SingleConfirmationProposalModal(
      'subscription-modal',
      'jr-modal-wrapper',
      jrConfigGlobal,
      source
    ).init();
  } else {
    new ProposalModal(
      'subscription-modal',
      'jr-modal-wrapper',
      jrConfigGlobal,
      source
    ).init();
  }
}

export const loadAutoSubscriptionModal = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  const {
    canShowSubscriptionPopup,
    subscription: {
      popupPolicyType
    },
    isMobile,
    page: {
      isJobPreviewPage
    }
  } = jrConfigGlobal;

  if (isMobile && isMobileSafari()) {
    pageShowListener(loadAutoSubscriptionModal);
  }

  if (popupPolicyType === PolicyType.NO_POPUP || !canShowSubscriptionPopup) {
    return;
  }

  const cookieValue = readCookie(subscriptionCookieInfo.COOKIE_NAME);

  if (popupPolicyType === PolicyType.AFTER_LANDING && cookieValue === null) {
    createCookie(
      subscriptionCookieInfo.COOKIE_NAME,
      0,
      { days: subscriptionCookieInfo.COOKIE_EXPIRES });

    return;
  }

  if (isJobPreviewPage && !canShowSubscriptionPopupInJPP()) {
    return;
  }

  if (isSubscriptionPopupVisibile(cookieValue ? parseInt(cookieValue, 10) : null)) {
    JtagService.trackSubscriptionProposal('modal_auto');

    initModal(jrConfigGlobal, 'auto');

    createCookie(
      subscriptionCookieInfo.COOKIE_NAME,
      !cookieValue ? 1 : parseInt(cookieValue, 10) + 1,
      { days: subscriptionCookieInfo.COOKIE_EXPIRES });
  }
}

export const loadSubscriptionModal = (source: string, jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  const {
    canShowSubscriptionPopup
  } = jrConfigGlobal;

  if (canShowSubscriptionPopup) {
    JtagService.trackSubscriptionProposal(`modal_${source}`);
    initModal(jrConfigGlobal, source)
  }
}